import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteMenuSlice = createSlice({
    name: "deleteMenuRequest",
    initialState,
    reducers: {
        deleteMenuRequest(state) {
            state.loading = true;
        },
        deleteMenuRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteMenuRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteMenuStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteMenuRequest,
    deleteMenuRequestSuccess,
    deleteMenuRequestError,
    deleteMenuStateReset,
} = DeleteMenuSlice.actions;

export default DeleteMenuSlice.reducer;
